import classNames from 'classnames';
import * as React from 'react';

import { NavbarDropdownItem } from 'bones/components/molecules/Navbar/types';
import { Icon } from 'bones/design-system/components/icons/Icon';
import { KnowledgeCatalogLogo } from 'bones/design-system/components/icons/KnowledgeCatalogLogo';
import { PortalLogo } from 'bones/design-system/components/icons/PortalLogo';
import { VoiceboxCircleLogo } from 'bones/design-system/components/icons/VoiceboxCircleLogo';
import { Body } from 'bones/design-system/components/typography/Body';
import { noop } from 'bones/utils/noop';

export const VOICEBOX_NAVBAR_DROPDOWN_ITEM: NavbarDropdownItem = {
  collapsed: (
    <div
      className={classNames(
        'vb-navbar-dropdown-item',
        'vb-navbar-dropdown-item--voicebox'
      )}
    >
      <Icon IconComponent={VoiceboxCircleLogo} size="xl" />
    </div>
  ),
  expanded: (
    <div
      className={classNames(
        'vb-navbar-dropdown-item',
        'vb-navbar-dropdown-item--voicebox'
      )}
    >
      <Icon IconComponent={VoiceboxCircleLogo} size="xl" />
      <Body size="sm">VOICEBOX</Body>
    </div>
  ),
  onClick: noop,
};

export const PORTAL_NAVBAR_DROPDOWN_ITEM: NavbarDropdownItem = {
  collapsed: (
    <div
      className={classNames(
        'vb-navbar-dropdown-item',
        'vb-navbar-dropdown-item--portal'
      )}
    >
      <Icon IconComponent={PortalLogo} size="xl" />
    </div>
  ),
  expanded: (
    <div
      className={classNames(
        'vb-navbar-dropdown-item',
        'vb-navbar-dropdown-item--portal'
      )}
    >
      <Icon IconComponent={PortalLogo} size="xl" />
      <Body size="sm">PORTAL</Body>
    </div>
  ),
  onClick: noop,
};

export const KNOWLEDGE_CATALOG_NAVBAR_DROPDOWN_ITEM: NavbarDropdownItem = {
  collapsed: (
    <div
      className={classNames(
        'vb-navbar-dropdown-item',
        'vb-navbar-dropdown-item--knowledge-catalog'
      )}
    >
      <Icon IconComponent={KnowledgeCatalogLogo} size="xl" />
    </div>
  ),
  expanded: (
    <div
      className={classNames(
        'vb-navbar-dropdown-item',
        'vb-navbar-dropdown-item--knowledge-catalog'
      )}
    >
      <Icon IconComponent={KnowledgeCatalogLogo} size="xl" />
      <Body size="sm">CATALOG</Body>
    </div>
  ),
  onClick: noop,
};
